module.exports = "pegasus/assets/email1-column-12.png";